import { render, staticRenderFns } from "./sso_module.vue?vue&type=template&id=0331b10a&scoped=true"
import script from "./sso_module.vue?vue&type=script&lang=js"
export * from "./sso_module.vue?vue&type=script&lang=js"
import style0 from "./sso_module.vue?vue&type=style&index=0&id=0331b10a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0331b10a",
  null
  
)

export default component.exports